export default __webpack_public_path__ + "static/media/discount.966eebdc.svg";